/*
 * @Date: 2019-10-08 11:21:21
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-07-28 14:21:11
 */
import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import { PREFIX_KS_SORDER, PREFIX_SORDER } from '@/service'
const api = {
  columnConfig: `${utils.hostname('cms')}/publish/999/personalorderlist.json`,
  orderList: PREFIX_SORDER + 'UOrder/queryAllOrderList.do'
}
export default {
  async getColumnData({ commit }) {
    try {
      const settings = await fetch(api.columnConfig)
      const settingsJson = await settings.json()
      if (settingsJson) {
        commit('setColumnData', settingsJson.data)
      }
    } catch (e) {
      console.log(e)
    }
  },
  // 根据uid、订单状态获取订单列表
  async getOrderListWithPageAndState(
    { commit, state },
    { uid, skey, status, page_size, page_num }
  ) {
    try {
      const query_param = {
        pageSize: page_size,
        pageIndex: page_num,
        uid,
        skey,
        orderState: status,
        flag: ''
      }
      const query = JSON.stringify(query_param)
      const order_res = await fetch(`${api.orderList}?param=${query}`)
      const orderListJson = await order_res.json()
      let orderList = []
      if (orderListJson.code === '1') {
        orderList = orderListJson.data.list || []
        commit('setOrderList', orderList)
      } else if (orderListJson.code === '4') {
        utils.login()
      }
      return orderList
    } catch (e) {
      throw new Error(e.message)
    }
  }
}
